import React, { Component } from 'react';
import './index.scss';

class AnswerSelectRow extends Component {
  render() {
    if (!this.props.answer) return null;
    return (
      <div className="col-12 row answer-select">
        <span className="col-3">{this.props.answer.name}</span>
        <span className="col-3">{this.props.answer.bot_tags.join(', ')}</span>
        <span className="col-1">
          <i
            className={
              this.props.answer.type === 'skill'
                ? 'fa fa-bullseye'
                : 'far fa-comments'
            }
          ></i>
        </span>
        <span className="col-5">
          {this.props.answer.skill_name
            ? this.props.answer.skill_name
            : this.props.answer.answers[0].content}
        </span>
      </div>
    );
  }
}

export default AnswerSelectRow;
